import { store, getEmptyData, OrcasStoreData } from '@/store'
import { IFeatureFlags } from '@sennder/senn-node-microfrontend-interfaces'

export const setStoreLanguage = async (language: string) => {
  store.state.data.language = language
}

export const clearState = () => {
  store.state.data = getEmptyData()
}

export const setStoreData = (data: OrcasStoreData) => {
  store.state.data = data
}

export const setStoreLegacyFlags = (flags: IFeatureFlags) => {
  store.state.data.featureFlags = {
    ...store.state.data.featureFlags,
    ...flags,
  }
}
